/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'

import {getCSS, getCSSVariableValue} from '../../../../../../_metronic/assets/ts/_utils'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { DateCompleteAno, DateCompleteMesAno, formatDateInverter, getShortMonthNameString } from '../../../../../utils/date'
import { KTSVG } from '../../../../../../_metronic/helpers'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
import { ptBR } from "date-fns/locale/pt-BR";
import useSize from '../../../../../hooks/useSize'
import { LoadingSpan } from '../../../Loadings/loadingSpan'

type Props = {
  className: string;
  charts: any;
  prognostico?: any
  myProg?: any
}

const BarGraph: React.FC<Props> = ({className, charts, prognostico, myProg}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const [listDates, setListDates] = useState<any>([]);
  const [listDatesString, setListDatesString] = useState<any>([]);
  const [myPrognostics, setMyPrognostics] = useState<any>(null);
  const [selectedValue, setSelectedValue] = useState<any>();
  const {width} = useSize()

  const [generation, setGeneration] = useState<string>("0"); 
  const [desempenho, setDesempenho] = useState<string>("0");

  const [chartsValues, setChartsValues] = useState({
    metaDates: [],
    valores: [],
    type: "" 
  });

  function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
}

  const handleChartDeploy = () => {
    if(charts && Object.keys(charts).length > 0){
      const myMetaDates = charts[selectedValue]["type"] && charts[selectedValue]["type"] === "mounth_charts" 
      ? charts[selectedValue]["dias"]
      : charts[selectedValue]["type"] && charts[selectedValue]["type"] === "year_charts"
      ? charts[selectedValue]["meses"]
      : charts["type"] && charts["type"] === "total_charts"
      ? charts["anos"] 
      : []

      const type = charts[selectedValue]["type"] ? charts[selectedValue]["type"] : ""

      const myValores = charts["type"] && charts["type"] === "total_charts" 
      ? charts["valores"]
      : charts[selectedValue]["valores"]


      const myGeneration = myValores.reduce((acumulador: number, valorAtual: number) => acumulador + valorAtual, 0);
      setGeneration(myGeneration ? myGeneration.toFixed(2).toString() : "0")

      if(myProg){
        if(charts && charts[selectedValue]["type"] === "mounth_charts"){
          const value = getShortMonthNameString(selectedValue)
          const value_prop = `prog_${value}`;
          const value_final = myProg[value_prop];

          //setMyPrognostics(value_final / 30)

          const [year, month] = selectedValue.split('-');
          const daysInMonth = getDaysInMonth(parseInt(year, 10), parseInt(month, 10));

          const my_array = myMetaDates ? Array(myMetaDates.length).fill(parseFloat(((value_final)/daysInMonth).toFixed(2))) : [] 
          setMyPrognostics(my_array)

          const porcentagem_prognostico = (myGeneration / value_final) * 100
          setDesempenho(porcentagem_prognostico ? porcentagem_prognostico.toFixed(2).toString() : "0")

        }else if(charts && charts[selectedValue]["type"] === "year_charts"){
          const my_array = myMetaDates.map(dateString => {
            const shortMonthName = getShortMonthNameString(dateString);
            const propertyName = `prog_${shortMonthName}`;
            return myProg[propertyName] !== null ? myProg[propertyName] : 0;
        });

        setMyPrognostics(my_array)
        const somaTotalPrognostico = my_array.reduce((acumulador, valorAtual) => acumulador + valorAtual, 0);
        const porcentagem_prognostico = (myGeneration / somaTotalPrognostico) * 100

        setDesempenho(porcentagem_prognostico && porcentagem_prognostico !== Infinity ? porcentagem_prognostico.toFixed(2).toString() : "0")

        }else{
          const my_array = prognostico ? Array(myMetaDates.length).fill(parseFloat(((prognostico)).toFixed(2))) : []
          setMyPrognostics(my_array)
        }
      }

      setChartsValues({
        metaDates: myMetaDates,
        valores: myValores,
        type: type 
      })
    }
  }

  const handleChange = (myData: any) => {
    //setStartDate(newStartDate);
    //setEndDate(newEndDate);
    const dateModificad = DateCompleteMesAno(myData)

    const teste = listDates.map((chart: any) => {
      return chart[0]
    })

    const existsInArray = teste.includes(dateModificad);

    if(existsInArray){
      setSelectedValue(dateModificad);
    }
  };

  const handleChangeYear = (myData: any) => {
    //setStartDate(newStartDate);
    //setEndDate(newEndDate);
    const dateModificad = DateCompleteAno(myData)

    const teste = listDates.map((chart: any) => {
      return chart[0]
    })

    const existsInArray = teste.includes(dateModificad);

    if(existsInArray){
      setSelectedValue(dateModificad);
    }
  };

  
  useEffect(() => {
    handleChartDeploy()
    
  }, [selectedValue])

  
  useEffect(() => {
      if(charts){
        const string_date : string = Object.keys(charts)[0]
        setSelectedValue(string_date)
        const list = Object.entries(charts);
        setListDates(list)

        const teste = list.map((chart: any) => {
          return chart[0]
        })

        setListDatesString(teste)
      }

  }, [charts])


  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, chartsValues])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, chartsValues.valores, chartsValues.metaDates, chartsValues.type, myPrognostics ? myPrognostics : null))
    if (chart) {
      chart.render()
    }
    return chart
  }

  if (!charts) {
    return (
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', height: '15rem', alignItems: 'center'}}>
        <LoadingSpan style={{marginLeft: '0.5rem'}}/>
      </div>
    )
  }


  return (
    <div className={`${width < 1200 ? '' : 'card'} ${className}`}>
      {((charts && !charts['type']) || charts["type"] !== "total_charts") && (
        <div className='card-header border-0 pt-1' style={{alignItems: 'center'}}>
          {/* <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>{selectedValue}</span>
          </h3>
          <div className='card-toolbar' data-kt-buttons='true'>
            <div className='d-flex align-items-center my-2'>
              <div className='w-130px me-5'>
                <select
                  name='status'
                  data-control='select2'
                  data-hide-search='true'
                  className='form-select form-select-white form-select-sm'
                  value={selectedValue}
                  onChange={handleSelectChange}
                >
                  {
                    listDates.map((chart: any) => {
                      return (
                        <option value={chart[0]}>{chart[0]}</option>
                      );
                    })
                  }
                </select>
              </div>
            </div>
          </div> */}

        <div style={{display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: width < 1200 ? '1rem' : '0rem', marginTop: width < 1200 ? '1rem' : '0rem'}}>
          <div>
            <KTSVG
              path='/media/icons/duotune/graphs/gra005.svg'
              className='svg-icon-3x ms-2 me-0'
            />
          </div>
          <div>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-7 mb-0'><span className='text-muted'>Gerado -</span> {generation} KWh</span>
            </h3>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-7 mb-0'><span className='text-muted'>Desempenho -</span>  {desempenho && desempenho !== "Infinity" ? desempenho : "0"}%</span>
            </h3>
          </div>
        </div>

        {charts && charts[selectedValue] && charts[selectedValue]["type"] === "mounth_charts"  ?
          <div>
            <DatePicker
              showIcon
              //isClearable
              className="form-control form-control-sm"
              selected={new Date(new Date(selectedValue ? selectedValue : '').setDate(new Date(selectedValue ? selectedValue : '').getDate() + 1))}
              onChange={handleChange}
              showMonthYearPicker
              dateFormat="MM/yyyy"
              includeDates={listDatesString.map(month => {
                const [year, monthIndex] = month.split('-');
                return new Date(year, monthIndex - 1, 1);
              })}
              locale={ptBR}
              //minDate={startDate}
              //minDate={new Date(new Date(dateAntigaMetaDates ? dateAntigaMetaDates : '').setDate(new Date(dateAntigaMetaDates ? dateAntigaMetaDates : '').getDate() + 1))}
              //maxDate={new Date(new Date(dateAtualMetaDates ? dateAtualMetaDates : '').setDate(new Date(dateAtualMetaDates ? dateAtualMetaDates : '').getDate() + 0))}

              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="3em"
                  height="3em"
                  viewBox="0 0 48 48"
                >
                  <mask id="ipSApplication0">
                    <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                      <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                      <path
                        fill="#fff"
                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                      ></path>
                    </g>
                  </mask>
                  <path
                    fill="currentColor"
                    d="M0 0h48v48H0z"
                    mask="url(#ipSApplication0)"
                  ></path>
                </svg>
              }
            />
          </div>
        :
        charts && charts[selectedValue] && charts[selectedValue]["type"] === "year_charts" ?
          <div>
            <DatePicker
              showIcon
              //isClearable
              className="form-control form-control-sm"
              selected={new Date(new Date(selectedValue ? selectedValue : '').setDate(new Date(selectedValue ? selectedValue : '').getDate() + 1))}
              onChange={handleChangeYear}
              showYearPicker
              dateFormat="yyyy"
              includeDates={listDatesString.map(year => {
                return new Date(year, 0, 1);
              })}
              locale={ptBR}
              //minDate={startDate}
              //minDate={new Date(new Date(dateAntigaMetaDates ? dateAntigaMetaDates : '').setDate(new Date(dateAntigaMetaDates ? dateAntigaMetaDates : '').getDate() + 1))}
              //maxDate={new Date(new Date(dateAtualMetaDates ? dateAtualMetaDates : '').setDate(new Date(dateAtualMetaDates ? dateAtualMetaDates : '').getDate() + 0))}
            />
          </div>
          : <></>
        }

        </div>
      )}

      <div className='card-body' style={{overflowX: "auto"}}>
        <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: '350px', width: '100%'}} />
      </div>
    </div>
  )
}

export {BarGraph}

function getChartOptions(height: number, valores: any, metaDates: any, type: any, prognostico?: any): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--bs-primary')
  const secondaryColor = getCSSVariableValue('--bs-gray-300')

  const formattedDates = metaDates.map(formatDateInverter);

  return {
    series: [
      {
        name: 'Energia Gerada',
        type: 'bar',
        data: valores,
      },
      {
        name: 'Prognóstico',
        type: 'line',
        data: prognostico ? prognostico : []
      }
    ],
    // chart: {
    //   fontFamily: 'inherit',
    //   type: 'bar',
    //   height: height,
    //   toolbar: {
    //     show: false,
    //   },
    // },

    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: 350,
      toolbar: {
        show: true,
        
        tools: {
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          download: true,
          // customIcons: [
          //   {
          //     icon: 'Download',
          //     click: () => {
          //       console.log('custom icon clicked')
          //     }
          //   }
          // ],
          //selection: true,
        },
      },
      zoom: {
        enabled: true,
        type: 'x',
        autoScaleYaxis: true,
        zoomedArea: {
          fill: {
            color: baseColor,
            opacity: 0.2
          },
          stroke: {
            color: baseColor,
            opacity: 0.4,
            width: 1
          }
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: type === "mounth_charts" ? '50%' : type === "year_charts" ? "30%" : "20%",
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: [0, 3],
      colors: ['transparent', prognostico ?  '#f1416c' : 'labelColor'],  // Cor para a linha
      curve: 'smooth'
    },
    xaxis: {
      categories: formattedDates,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: [
      {
        min: 0,
        seriesName: 'Energia Gerada',
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: baseColor
        },
        labels: {
          style: {
            colors: baseColor,
          }
        },
        title: {
          text: "Geração (KWh)",
          style: {
            color: baseColor,
          }
        },
        tooltip: {
          enabled: true
        }
      },
    ],
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
          if (seriesIndex === 1) {
            return val + ' KWh (Prognóstico)';
          }
          return val + ' KWh';
        },
      },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  };
}



